import React, { useState } from 'react'
import { BodyText, Button, Col, HeadingText, Row } from '@paypalcorp/pp-react'

import './article-feedback.less'
import { Message } from '@paypalcorp/worldready-react'
import useTracking from '../../hooks/useTracking'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'
import { ARTICLE_FEEDBACK_DATA } from '../../utils/prop-type-shape'

const { YES, NO } = {
  YES: 'Y',
  NO: 'N',
}

const HCAR_MAPPINGS = {
  Y: 'Y',
  N: 'N99',
}

function ArticleFeedback({ articleId, helpComponentIds }) {
  const [isArticleHelpful, setIsArticleHelpful] = useState('')
  const { trackClick } = useTracking()

  const captureFeedback = (answer) => {
    setIsArticleHelpful(answer)
    const hcar = HCAR_MAPPINGS[answer]
    trackClick({
      name: componentNames.ARTICLE_FEEDBACK,
      type: fptiTypes.ON_CLICK,
      hcar,
      hcaf: `${articleId}|${hcar}`,
      hpid: articleId,
      help_doc_id: articleId,
      help_component_ids: helpComponentIds,
      link: `${componentNames.ARTICLE_FEEDBACK}|${articleId}|feedback`,
    })
  }

  const renderFbSection = () => {
    if (!isArticleHelpful) {
      return (
        <>
          <Col xs={12} md={7}>
            <HeadingText
              data-testid="hc-article-fb-heading"
              className="hc_article_fb__heading"
              size="sm"
            >
              <Message id="app.article.feedback.header" />
            </HeadingText>
          </Col>
          <Col>
            <div className="hc_article_fb__answer">
              <Button
                data-testid="hc-article-fb-btn-yes"
                className="hc_article_fb__answer--spacing"
                onClick={() => captureFeedback(YES)}
                size="sm"
              >
                <Message id="app.article.feedback.select.yes" />
              </Button>
              <Button
                data-testid="hc-article-fb-btn-no"
                onClick={() => captureFeedback(NO)}
                size="sm"
                secondary
              >
                <Message id="app.article.feedback.select.no" />
              </Button>
            </div>
          </Col>
        </>
      )
    }

    return null
  }

  const renderFbRecieved = () => {
    if (isArticleHelpful) {
      return (
        <Col>
          <BodyText className="hc_article_fb__heading">
            <Message id="app.article.feedback.greeting.success" />
          </BodyText>
        </Col>
      )
    }

    return null
  }

  return (
    <>
      <Row>
        {renderFbRecieved()}
        {renderFbSection()}
      </Row>
    </>
  )
}

ArticleFeedback.propTypes = ARTICLE_FEEDBACK_DATA

export default ArticleFeedback
